type ScrollRestoreSource = 'close-article' | 'reader-action';

interface ListScrollRestore {
  scrollTop: number;
  targetPath: string;
  source: ScrollRestoreSource;
  timestamp: number;
}

let listScrollRestore: ListScrollRestore | null = null;

function setListScrollRestore(payload: ListScrollRestore): void {
  listScrollRestore = payload;
}

function getListScrollRestore(): ListScrollRestore | null {
  return listScrollRestore;
}

function clearListScrollRestore(): void {
  listScrollRestore = null;
}

// Live memory of the last scroll offset a visible list had, keyed by list path.
// Unlike the restore payload above, this is NOT cleared when an article opens,
// so a full-screen reader can recover "where the list was" after the list area
// has collapsed (and its DOM scrollTop is no longer reliable).
let rememberedListScroll: { path: string; scrollTop: number } | null = null;

function rememberListScroll(path: string, scrollTop: number): void {
  rememberedListScroll = { path, scrollTop };
}

function getRememberedListScroll(path: string): number | null {
  return rememberedListScroll && rememberedListScroll.path === path
    ? rememberedListScroll.scrollTop
    : null;
}

export type { ListScrollRestore, ScrollRestoreSource };
export {
  setListScrollRestore,
  getListScrollRestore,
  clearListScrollRestore,
  rememberListScroll,
  getRememberedListScroll,
};
